import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RefreshStateService {
  isRefreshing = false;
  readonly tokenSubject = new BehaviorSubject<string | null>(null);
}
